module.exports = __webpack_public_path__ + "img/payFailed.2c03de20.png";